export function getBrowserLanguage() {
  const language = navigator.language || navigator.userLanguage;
  return language.split('-')[0];
}

export function getCountryByLanguage(languageCode, countries) {
  const languageCountryMap = {
    'en': 'United States',
    'de': 'Germany', 
    'fr': 'France',
    'es': 'Spain',
    'it': 'Italy',
    'pt': 'Portugal',
    'nl': 'Netherlands',
    'sv': 'Sweden',
    'no': 'Norway',
    'da': 'Denmark',
    'fi': 'Finland',
    'pl': 'Poland',
    'cs': 'Czech Republic',
    'hu': 'Hungary',
    'ro': 'Romania',
    'bg': 'Bulgaria',
    'hr': 'Croatia',
    'sk': 'Slovakia',
    'sl': 'Slovenia',
    'et': 'Estonia',
    'lv': 'Latvia',
    'lt': 'Lithuania',
    'el': 'Greece',
    'tr': 'Turkey',
    'ru': 'Russia',
    'uk': 'Ukraine',
    'be': 'Belarus',
    'ka': 'Georgia',
    'hy': 'Armenia',
    'az': 'Azerbaijan',
    'kk': 'Kazakhstan',
    'ky': 'Kyrgyzstan',
    'uz': 'Uzbekistan',
    'tg': 'Tajikistan',
    'mn': 'Mongolia',
    'zh': 'China',
    'ja': 'Japan',
    'ko': 'Korea, Republic of South Korea',
    'th': 'Thailand',
    'vi': 'Vietnam',
    'id': 'Indonesia',
    'ms': 'Malaysia',
    'tl': 'Philippines',
    'hi': 'India',
    'bn': 'Bangladesh',
    'ur': 'Pakistan',
    'fa': 'Iran, Islamic Republic of Persian Gulf',
    'ar': 'Saudi Arabia',
    'he': 'Israel',
    'sw': 'Tanzania, United Republic of Tanzania',
    'am': 'Ethiopia',
    'yo': 'Nigeria',
    'zu': 'South Africa',
    'af': 'South Africa'
  };

  const countryName = languageCountryMap[languageCode];
  if (!countryName) {
    return null;
  }

  return countries.find(country => country.name === countryName);
}

export function getLanguageByBrowserLanguage(browserLanguage, availableLanguages) {
  const languageMap = {
    'en': 'English',
    'de': 'German',
    'fr': 'French',
    'es': 'Spanish',
    'tr': 'Turkish'
  };

  const mappedLanguage = languageMap[browserLanguage];
  if (mappedLanguage && availableLanguages.includes(mappedLanguage)) {
    return mappedLanguage;
  }

  return 'English';
}